import { apiClient } from '../config';

export default {
  getAutoCall (params) {
    return apiClient.get('/auto-calls', { params });
  },
  getAutoCallRunId (run_id, params) {
    return apiClient.get(`/auto-calls/${run_id}`, { params });
  },
  getAutoCallRunIdTasks (run_id, params) {
    return apiClient.get(`/auto-calls/${run_id}/tasks`, { params });
  },
  getAutoCallRunIdStats (run_id, params) {
    return apiClient.get(`/auto-calls/${run_id}/stats`, { params });
  },
  autoCall (params) {
    return apiClient.post('/auto-calls', params);
  },
  autoCallCustom (params) {
    return apiClient.post('/auto-calls/custom', params);
  },
  editAutoCallRun (run_id, params) {
    return apiClient.patch(`/auto-calls/${run_id}`, params);
  },
  updateAutoCallRunId (run_id, params) {
    return apiClient.put(`/auto-calls/${run_id}/status`, params);
  },
  updateTaskAutoCall (run_task_id, params) {
    return apiClient.put(`/auto-calls/tasks/${run_task_id}/status`, params);
  },
  archiveAutoCallRunId (run_id) {
    return apiClient.delete(`/auto-calls/${run_id}/archive`);
  },
  autoCallReport (params) {
    return apiClient.post('/reports/auto-calls', params);
  }
};
